import { call, put, takeLatest } from 'redux-saga/effects';
import { REST_API } from '../../../constants/serverUrls';
import { opportunityDetailActions } from './opportunityDetailState';
import {
  getDatas,
  getDataById,
  saveData,
} from '../../../services/base.service';

function* getData({ payload }) {
  try {
    const result = yield call(getDataById, REST_API.OPPORTUNITY.OPPORTUNITY.OPPORTUNITY_ID, payload);
    yield put(opportunityDetailActions.getDataSuccess(result));
  } catch (_) { }
}

function* save({ payload }) {
  try {
    const result = yield call(saveData, REST_API.OPPORTUNITY.OPPORTUNITY.OPPORTUNITY, payload);
    yield put(opportunityDetailActions.saveDataSuccess(result));
  } catch (_) { }
}

function* getOrderDetails({ payload }) {
  try {
    const result = yield call(getDatas, REST_API.OPPORTUNITY.OPPORTUNITY.OPPORTUNITY_ORDER, payload);
    yield put(opportunityDetailActions.getOrderDetailsSuccess(result));
  } catch (_) { }
}

function* getEstimateDetails({ payload }) {
  try {
    const result = yield call(getDatas, REST_API.OPPORTUNITY.OPPORTUNITY.OPPORTUNITY_ESTIMATE, payload);
    yield put(opportunityDetailActions.getEstimateDetailsSuccess(result));
  } catch (_) { }
}

function* getPdfData({ payload }) {
  try {
    const result = yield call(getDataById, REST_API.OPPORTUNITY.OPPORTUNITY.REPORT, payload);
    yield put(opportunityDetailActions.getPdfDataSuccess(result));
  } catch (_) { }
}

function* getDeliveryDatas({ payload }) {
  try {
    const result = yield call(getDatas, REST_API.OPPORTUNITY.OPPORTUNITY.DELIVERYS, payload);
    yield put(opportunityDetailActions.getDeliveryDatasSuccess(result));
  } catch (_) { }
}

function* saveAnswer({ payload }) {
  try {
    yield call(saveData, REST_API.OPPORTUNITY.OPPORTUNITY.ANSWER, payload);
    yield put(opportunityDetailActions.saveAnswerSuccess());
  } catch (_) { }
}

function* opportunityDetailSaga() {
  yield takeLatest('opportunityDetail/getData', getData);
  yield takeLatest('opportunityDetail/saveData', save);
  yield takeLatest('opportunityDetail/getOrderDetails', getOrderDetails);
  yield takeLatest('opportunityDetail/getEstimateDetails', getEstimateDetails);
  yield takeLatest('opportunityDetail/getPdfData', getPdfData);
  yield takeLatest('opportunityDetail/getDeliveryDatas', getDeliveryDatas);
  yield takeLatest('opportunityDetail/saveAnswer', saveAnswer);
}

export default opportunityDetailSaga;
